import { useCallback } from 'react'
import { Icon, Tooltip } from '@/client/components'
import { useGetCartItems, useRouterPush } from '@/client/hooks'
import { ROUTER_PATH } from '@/client/utils'
import * as S from './styles'

const Cart = () => {
  const { routerPush, defaultLocale } = useRouterPush()
  const { data, isLoading } = useGetCartItems()

  const handleClickCart = useCallback(
    (e) => {
      e.preventDefault()
      routerPush(ROUTER_PATH.CART[defaultLocale])
    },
    [routerPush, defaultLocale]
  )

  return (
    <S.Cart onClick={handleClickCart}>
      <S.CartBag>
        {!isLoading && data && <S.CartNumber>{data?.quantity_items}</S.CartNumber>}
        <Icon name='cartbox' className='cartbox' size='s5' />
      </S.CartBag>
    </S.Cart>
  )
}

export default Cart
